import { useQuery } from "@tanstack/react-query";
import { getBenefits } from "../services/benefitService";

export const useBenefits = (token?: string | null) => {
  return useQuery({
    queryKey: ["benefits"],
    queryFn: () => getBenefits(token as string),
    enabled: !!token,
    staleTime: 2 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};